
(() => {
  const colorMap = {
    "black":"#171717",
    "white":"#f8f8f5",
    "ash":"#e5e5e1",
    "athletic heather":"#c4c4c1",
    "dark grey heather":"#4b4b4b",
    "dark gray heather":"#4b4b4b",
    "heather navy":"#344154",
    "navy":"#24314b",
    "heather true royal":"#5575b4",
    "true royal":"#315fbd",
    "columbia blue":"#78afd0",
    "aqua":"#65c2c8",
    "teal":"#2f8f8a",
    "kelly":"#328a57",
    "heather kelly":"#57936f",
    "military green":"#65694c",
    "forest":"#31543a",
    "olive":"#70724f",
    "gold":"#e3a72d",
    "mustard":"#d39d32",
    "orange":"#e17035",
    "heather orange":"#c77c51",
    "heather autumn":"#a75637",
    "red":"#c8403e",
    "heather red":"#b75856",
    "maroon":"#6d3340",
    "pink":"#efb3c3",
    "soft pink":"#efb3c3",
    "lilac":"#bea5ca",
    "purple":"#66508d",
    "heather purple":"#786988",
    "heather dust":"#d6cec2",
    "natural":"#e9dfca",
    "soft cream":"#f2e5c9",
    "silver":"#c7c9c8",
    "charity pink":"#e8a8c5",
    "dark heather":"#4a4b4d",
    "deep teal":"#185c60",
    "fuchsia":"#c33178",
    "heliconia":"#d82983",
    "irish green":"#308447",
    "light blue":"#a5c6e3",
    "light pink":"#f0b6cf",
    "oxblood black":"#39282c",
    "pebble brown":"#826d60",
    "royal":"#385eb7",
    "sand":"#e9dfc7",
    "sport grey":"#c4c5c4",
    "slate":"#657079"
  };

  const normalize = value => String(value || "").trim().toLowerCase();

  function enhanceVariantPickers(root = document) {
    const pickers = [];
    if (root.matches && root.matches("variant-selects")) pickers.push(root);
    if (root.querySelectorAll) pickers.push(...root.querySelectorAll("variant-selects"));
    pickers.forEach(picker => {
      picker.querySelectorAll("fieldset.product-form__input--pill").forEach(fieldset => {
        const legend = fieldset.querySelector("legend");
        const firstInput = fieldset.querySelector('input[type="radio"]');
        if (!legend || !firstInput) return;

        const rawName = (firstInput.name || legend.textContent || "").toLowerCase();

        if (rawName.includes("color") || rawName.includes("colour")) {
          fieldset.classList.add("drumz-color-swatches");
          const selected = fieldset.querySelector('input[type="radio"]:checked');
          if (!legend.querySelector("[data-drumz-selected-color]")) {
            const label = legend.textContent.replace(/:.*/, "").trim() || "Color";
            legend.innerHTML = label.toUpperCase() + ': <span data-drumz-selected-color></span>';
          }
          const selectedLabel = legend.querySelector("[data-drumz-selected-color]");
          const updateSelected = () => {
            const active = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedLabel) selectedLabel.textContent = active ? active.value : "";
          };

          fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (!label) return;
            const key = normalize(input.value);
            const swatch = colorMap[key] || "#d7d3cc";
            label.style.setProperty("--drumz-swatch", swatch);
            label.setAttribute("title", input.value);
            label.setAttribute("aria-label", input.value);
            input.addEventListener("change", updateSelected, {passive:true});
          });
          updateSelected();
        }

        if (rawName.includes("size")) {
          const rank = new Map(["XS","S","M","L","XL","2XL","3XL","4XL","5XL"].map((v,i)=>[v,i]));
          const pairs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input, index) => ({
            input,
            label: fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]'),
            rank: rank.has(input.value.toUpperCase()) ? rank.get(input.value.toUpperCase()) : 100 + index
          }));
          pairs.sort((a,b)=>a.rank-b.rank);
          const frag = document.createDocumentFragment();
          pairs.forEach(pair => {
            frag.appendChild(pair.input);
            if (pair.label) frag.appendChild(pair.label);
          });
          fieldset.appendChild(frag);
        }
      });
    });
  }

  function enhancePagination(root = document) {
    const scope = root.closest ? (root.closest("#ProductGridContainer") || root) : root;
    const grid = (scope.matches && scope.matches("#product-grid")) ? scope : scope.querySelector?.("#product-grid");
    const pagination = (scope.matches && scope.matches(".pagination-wrapper")) ? scope : scope.querySelector?.(".pagination-wrapper");
    if (!grid || !pagination || pagination.dataset.drumzEnhanced === "true") return;

    const next = pagination.querySelector("a.pagination__item--prev");
    if (!next) {
      pagination.remove();
      return;
    }

    pagination.dataset.drumzEnhanced = "true";
    const wrap = document.createElement("div");
    wrap.className = "drumz-load-more-wrap";
    const button = document.createElement("button");
    button.type = "button";
    button.className = "drumz-load-more";
    button.textContent = "Load more";
    wrap.appendChild(button);
    pagination.replaceWith(wrap);

    let loading = false;
    const loadMore = async () => {
      if (loading || !next.href) return;
      loading = true;
      button.disabled = true;
      button.textContent = "Loading…";
      try {
        const response = await fetch(next.href, {credentials:"same-origin"});
        if (!response.ok) throw new Error("Failed to load");
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector("#product-grid");
        if (!newGrid) throw new Error("No grid");
        Array.from(newGrid.children).forEach(item => {
          item.classList.remove("scroll-trigger","animate--slide-in");
          item.removeAttribute("data-cascade");
          item.style.removeProperty("--animation-order");
          grid.appendChild(item);
        });

        const nextPagination = doc.querySelector(".pagination-wrapper");
        const nextNext = nextPagination?.querySelector("a.pagination__item--prev");
        if (nextNext) {
          next.href = nextNext.href;
          button.disabled = false;
          button.textContent = "Load more";
          observe();
        } else {
          wrap.remove();
        }
      } catch (err) {
        button.disabled = false;
        button.textContent = "Load more";
      } finally {
        loading = false;
      }
    };

    button.addEventListener("click", loadMore);

    let io;
    const observe = () => {
      if (!("IntersectionObserver" in window) || !document.body.contains(button)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) {
          io.disconnect();
          loadMore();
        }
      }, {rootMargin:"600px 0px"});
      io.observe(button);
    };
    observe();
  }

  function applyDefaultShopSort() {
    const path = window.location.pathname.replace(/\/$/,"");
    const url = new URL(window.location.href);
    if (path.endsWith("/collections/all-products") && !url.searchParams.has("sort_by")) {
      url.searchParams.set("sort_by","best-selling");
      window.location.replace(url.toString());
      return true;
    }
    return false;
  }

  function init(root = document) {
    enhanceVariantPickers(root);
    enhancePagination(root);
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (applyDefaultShopSort()) return;
    init(document);
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) init(node);
        }
      }
    });
    observer.observe(document.body, {childList:true,subtree:true});
  });
})();
